module.exports = __webpack_public_path__ + "static/img/cj2024.895f5e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cj2024.jpg?1.2
// module id = EaQz
// module chunks = 1